module.exports = __webpack_public_path__ + "static/media/discover.2fb1a8a7.png";